'use strict';

function OverbookingManagementGridDirective() {
  return {
    restrict: 'E',
    template: require('../templates/overbooking-management-grid.html'),
    controller: 'OverbookingManagementGridController',
    scope: {
      selectedFlights: '<',
      reoptPreviewData: '='
    },
    link: function link(scope) {
      scope.$watch('selectedFlights', scope.onSelectFlights);
      scope.$on('collapsable-panel-trigger', scope.onPanel);
    }
  };
}
OverbookingManagementGridDirective.$inject = [];
module.exports = OverbookingManagementGridDirective;